import { render, staticRenderFns } from "./QuoteFormCRMActionsSidebar.vue?vue&type=template&id=2d3c8314&scoped=true"
import script from "./QuoteFormCRMActionsSidebar.vue?vue&type=script&lang=js"
export * from "./QuoteFormCRMActionsSidebar.vue?vue&type=script&lang=js"
import style0 from "./QuoteFormCRMActionsSidebar.vue?vue&type=style&index=0&id=2d3c8314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c8314",
  null
  
)

export default component.exports